document.addEventListener("DOMContentLoaded", function () {
  const html = document.documentElement;
  const header = document.querySelector(".header");
  const menuBtn = document.querySelector(".js-menu-btn");
  const btnCTA = document.querySelector(".btn--cta");
  const menuMain = document.querySelector(".menu-main");
  const herdLogo = document.querySelector(".herd-logo");

  menuBtn.addEventListener("click", function () {
    menuBtn.classList.toggle("active");
    html.classList.toggle("overflow-hidden");
    header.classList.toggle("header--menu");
    header.classList.remove("header--scroll");
    btnCTA.classList.toggle("active");
    menuMain.classList.toggle("active");
    herdLogo.classList.toggle("active");
  });

  document.querySelectorAll(".menu-main__btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const parentItem = btn.closest(".menu-main__item");

      document
        .querySelectorAll(".menu-main__item.active")
        .forEach(function (item) {
          if (item !== parentItem) {
            item.classList.remove("active");
          }
        });

      if (parentItem) {
        parentItem.classList.toggle("active");
      }
    });
  });
});
